// extracted by mini-css-extract-plugin
export default {"cardContainer":"oWBc1prM","mobile":"mobile","rubric":"E7gT1R7M","overlay":"Qx1LgeBn","link":"AqfuWw8f","cardTextContent":"ucXiurlE"};